<template>
<v-app>
  <!-- <AppNavigationDrawer /> -->
  <AppToolbar />
  <AppInputDrawer />

  <v-main>
    <v-container fluid class="pa-0">
      <v-row no-gutters justify="center">
        <v-col cols="12">
          <v-slide-y-reverse-transition mode='out-in'>
            <router-view />
          </v-slide-y-reverse-transition>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
  <AppFooter />
</v-app>
</template>


<script>
import AppNavigationDrawer from '@/components/shared/NavigationDrawer'
import AppToolbar          from '@/components/shared/Toolbar'
import AppFooter           from '@/components/shared/Footer'
import AppInputDrawer      from '@/components/subs/inputDrawer'

export default {
  data: () => ({
    settings: {
      minScrollbarLength: 300,
      maxScrollbarLength: 500,
      suppressScrollX   : true,
    },
    offsetTop: 0,
  }),
  created() {
    // this.$vuetify.theme.primary   = '#C7A754'
    // this.$vuetify.theme.techblue  = '#004D8C'
    // this.$vuetify.theme.techgold  = '#DDB95C'
    // this.$vuetify.theme.buzzgold  = '#EAAA00'
  },
  computed: {
    isHome() {
      return this.$route.path === '/'
    },
    //isSankey() {
    //  return this.$route.path === '/water-energy'
    //}
  },
  methods: {
  },
  watch: {
    '$vuetify.breakpoint'(to) {
      if(to.mdAndDown) _.debounce(() => this.drawer = false, 100)()
    }
  },
  mounted() {
    window.addEventListener('scroll', e => {
      this.offsetTop = window.scrollY
    })
  },
  components: {
    AppToolbar,
    AppNavigationDrawer,
    AppFooter,
    AppInputDrawer,
  }
}
</script>

<style lang='stylus'>
@import url('https://fonts.googleapis.com/css?family=Poppins')

::-webkit-scrollbar
  width  : 0.5rem
  /* display: block */

::-webkit-scrollbar-thumb
  background: #C7A754

.bold
  font-weight: bold !important
</style>


<style lang='stylus' scoped>
.scroll-area
  position: relative
  width   : 100%
  height  : 100%

</style>
